var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "204.000000pt",
    height: "145.000000pt",
    viewBox: "0 0 204.000000 145.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,145.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900 1387 c-625 -222 -837 -302 -853 -319 -22 -26 -22 -70 0 -96 10 -11 73 -39 140 -63 68 -24 123 -47 123 -51 0 -3 -10 -19 -23 -35 -61 -75 -107 -192 -107 -275 -1 -112 -49 -259 -120 -364 -55 -83 -39 -103 116 -140 155 -38 149 -45 149 169 0 130 -4 173 -18 217 -10 30 -21 83 -24 117 -5 55 -2 70 25 126 31 67 95 147 117 147 7 0 131 -43 276 -96 205 -75 276 -97 319 -98 47 -1 117 21 510 163 250 90 461 168 468 174 16 12 16 102 0 114 -26 20 -919 336 -960 340 -31 3 -69 -5 -138 -30z m482 -239 c186 -67 338 -125 338 -128 0 -8 -672 -250 -695 -250 -32 0 -417 142 -408 150 4 4 102 43 218 86 116 43 216 82 223 88 17 12 11 66 -9 79 -11 7 -89 -18 -302 -98 l-286 -107 -65 23 c-37 13 -66 26 -66 29 0 9 663 248 690 249 13 1 176 -54 362 -121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 628 c-3 -35 -13 -141 -23 -236 l-17 -173 39 -41 c105 -110 402 -175 678 -150 265 25 477 118 476 210 0 15 -7 90 -15 167 -8 77 -18 173 -21 213 -4 39 -10 72 -14 72 -3 0 -34 -10 -69 -21 l-63 -22 7 -86 c3 -47 11 -115 16 -151 5 -36 9 -84 9 -106 0 -41 -1 -42 -58 -67 -112 -50 -180 -61 -387 -61 -207 0 -275 11 -387 61 -57 25 -58 26 -58 67 0 22 4 70 9 106 5 36 13 103 16 150 l7 86 -64 22 c-34 12 -66 22 -69 22 -4 0 -9 -28 -12 -62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.30483f461d0a7680af44e6aa5605e8b2.svg";
export { ForwardRef as ReactComponent };